import { render, staticRenderFns } from "./ExportComponentDT.vue?vue&type=template&id=6f99b697&scoped=true&"
import script from "./ExportComponentDT.vue?vue&type=script&lang=js&"
export * from "./ExportComponentDT.vue?vue&type=script&lang=js&"
import style0 from "./ExportComponentDT.vue?vue&type=style&index=0&id=6f99b697&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99b697",
  null
  
)

export default component.exports